export function GameDone() {

  return (
    <div className="GameDone">
      <h2>Time's up!</h2>
    </div>
  );
}